// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PImportOutlinedSvg from "@fishx/icons-svg/es/asn/PImportOutlined";
import FishxIcon from '../components/FishxIcon';

var PImportOutlined = function PImportOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PImportOutlinedSvg
  }));
};

PImportOutlined.displayName = 'PImportOutlined';
export default React.forwardRef(PImportOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PImportOutlined.js
// module id = 3453
// module chunks = 0